// en_pms_manager_dashboard.ts
// Tłumaczenia dla ekranu Manager Dashboard (ManagerDashboard.tsx)
// Statusy pokoi, akcje, common labels → importuj z en_pms_common.ts

export const enPmsManagerDashboard = {

  // ── Tytuły modali szczegółów ──────────────────────────────────────────────
  detailTitles: {
    rooms:    { title: "Rooms and inventory health",        sub: "Live room status across all floors" },
    guest:    { title: "Guest experience",                 sub: "Satisfaction, reviews and service recovery (last 90 days)" },
    dept:     { title: "Department overview",              sub: "Status, workload and exceptions by department (today)" },
    segments: { title: "Top demand segments",              sub: "Room nights and revenue by segment (last 28 days)" },
    market:   { title: "Market and pace",                   sub: "Benchmark against the comp set" },
    labor:    { title: "Labor overview",                    sub: "Staffing and costs by department (today)" },
    risk:     { title: "Operational risk queue",           sub: "Active risks requiring attention" },
  },

  // ── Pasek KPI ─────────────────────────────────────────────────────────────
  kpi: {
    occupancy:        "Occupancy",
    adr:              "ADR",
    revpar:           "RevPAR",
    revenueToday:     "Revenue today",
    forecastPickup:   "Forecast pickup",
    guestSatisfaction:"Guest satisfaction",
    openIssues:       "Open issues",
    laborCoverage:    "Labor coverage",
    onTheBooks:       "On the books",
    onTarget:         "On target",
    belowPlan:        "Below plan",
    vsLY:             "vs UB",       // vs Ubiegły Rok
    vsFCST:           "vs PROG",     // vs Prognoza
  },

  // ── Sekcja wykres / Performance & Forecast ────────────────────────────────
  performanceForecast: {
    title:           "Performance & forecast",
    legendRevenue:   "Revenue ($)",
    legendOccupancy: "Occupancy (%)",
    revenueToday:    "Revenue today",
    revenueForecast: "Revenue forecast",
    next7Days:       "next 7 days",
  },

  // ── Pokoje i inwentarz ────────────────────────────────────────────────────
  rooms: {
    title:                  "Rooms and inventory health",
    viewDetails:            "View details",
    sellableInventory:      "Sellable inventory",
    housekeepingReadiness:  "Housekeeping readiness",
    outOfOrder:             "Out of order",
    blockedRooms:           "Blocked rooms",
    maintenanceImpact:      "Maintenance impact",
    blockedForRevenue:      "Blocked for revenue",
    noImpact:               "No impact",
    arrivalRoomsNotReady:   "Arrival rooms not ready",
    highPriority:           "High priority",
    allClear:               "All clear",
    // Szczegóły modalu
    totalRooms:             "All rooms",
    sellable:               "Sellable",
    occupied:               "Zajęte",
    available:              "Dostępne",
    dirtyBlocked:           "Dirty / blocked",
    byFloor:                "By floor",
    tableHeaders:           ["Floor", "Total", "Occupied", "Available", "Dirty", "Reserved", "O.O.O."],
    floorLabel:             "Floor",
    reservedForArrivals:    "reserved for upcoming arrivals",
    room:                   "room",
    rooms:                  "rooms",
    ofTotal:                "% of total",
    ofOccupancy:            "% occupancy",
  },

  // ── Doświadczenie gości ───────────────────────────────────────────────────
  guest: {
    title:             "Guest experience pulse",
    viewDetails:       "View details",
    satisfactionScore: "Satisfaction score",
    activeComplaints:  "Active complaints",
    vipArrivalsToday:  "VIP arrivals today",
    vipInHouse:        "in-house",
    highPriority:      "High priority",
    noneOpen:          "Brak otwartych",
    serviceRecovery:   "Service recovery",
    openCases:         "Open cases",
    reviewSentiment:   "Review sentiment",
    noReviewsYet:      "No reviews yet",
    responseSLA:       "Response SLA",
    onTarget:          "On target",
    belowTarget:       "Below target",
    noData:            "No data",
    noGuestData:       "No guest experience data.",
    positiveReviews:   "% pozytywnych",
    reviews:           "opinii",
    // Szczegóły modalu – tabela
    detailLabels: {
      satisfaction:    "Satysfakcja",
      reviews90d:      "Opinie (90d)",
      responseSLA:     "Response SLA",
      complaints:      "Active complaints",
      serviceRecovery: "Service recovery",
      openCasesLabel:  "otwarte sprawy",
      vipTodayInHouse: "VIP dziś / in-house",
    },
    sentiment: {
      label:    "Review sentiment",
      positive: "Pozytywny",
      neutral:  "Neutralny",
      negative: "Negatywny",
    },
  },

  // ── Przegląd działów ─────────────────────────────────────────────────────
  dept: {
    title:        "Department overview",
    viewAll:      "View all",
    noData:       "No labor data for today.",
    loading:      "Loading...",
    atRisk:       "At risk",
    onTrack:      "On track",
    tableHeaders: ["Department", "Status", "Workload", "Excep.", "Owner"],
    detailHeaders:["Department", "Owner", "Status", "Workload", "Scheduled", "Req.", "Coverage", "Excep."],
  },

  // ── Segmenty popytu ───────────────────────────────────────────────────────
  segments: {
    title:        "Top demand segments",
    stayDate:     "Stay date",
    viewAll:      "View all",
    noData:       "Brak pobytów z ostatnich 28 dni.",
    loading:      "Loading...",
    other:        "Other",
    total:        "Razem",
    tableHeaders: ["Segment", "Rooms", "% of total", "ADR", "RevPAR"],
    detailHeaders:["Segment", "Room nights", "% share", "Revenue", "ADR", "RevPAR"],
  },

  // ── Rynek i tempo ─────────────────────────────────────────────────────────
  market: {
    title:            "Market and pace",
    viewAll:          "View all",
    noData:           "Brak danych rynkowych.",
    asOf:             "Stan na",
    marketOccupancy:  "Market occupancy",
    marketADR:        "Market ADR",
    marketRevPAR:     "Market RevPAR",
    compSetIndex:     "Comp set index",
    aboveCompSet:     "Above comp set",
    belowCompSet:     "Below comp set",
    paceToForecast:   "Pace to forecast",
    revenueForecast7d:"Revenue forecast (7d)",
    vs28dAgo:         "vs 28 days ago",
    onPace:           "On pace",
    behindPace:       "Behind pace",
    noForecast:       "No forecast",
    description:      "Odchylenia porównują aktualny benchmark z tym samym wskaźnikiem sprzed 28 dni. Indeks comp set powyżej 100 oznacza, że obiekt wyprzedza konkurencję.",
  },

  // ── Przegląd zatrudnienia ─────────────────────────────────────────────────
  labor: {
    title:         "Labor overview",
    viewAll:       "View all",
    noData:        "Brak danych kadrowych.",
    coverage:      "Coverage",
    scheduled:     "Zaplanowane",
    totalCost:     "Total labor cost",
    vsRequired:    "vs required",
    required:      "required",
    byDept:        "By department",
    noPerDept:     "No per-department data.",
    onTarget:      "On target",
    belowPlan:     "Poniżej planu",
    noDataShort:   "No data",
    revenueOf:     "% przychodu",
    staffingGap:   "Staffing gap",
    fullyCovered:  "Fully covered",
    tableHeaders:  ["Department", "Scheduled", "Wymagane", "Coverage", "Owner"],
  },

  // ── Brief kierowniczy ─────────────────────────────────────────────────────
  leadershipBrief: {
    title:                   "Leadership brief",
    todaySummary:            "Today's summary",
    upcomingHighlights:      "Upcoming highlights",
    notes:                   "Notes",
    noActiveNotes:           "No active notes. Add one from Live Board.",
    noUpcomingGroupBlocks:   "No upcoming group blocks",
    pickupVsYesterday:       "Pickup vs yesterday",
    revenuePace:             "Revenue pace",
    compSetIndex:            "Comp Set Index",
    displacement:            "Displacement",
    today:                   "today",
    groupPrefix:             "Group: ",
    noReleaseDate:           "No release date",
    rooms:                   "rooms",
    room:                    "room",
    pickupOf:                "pickup",
  },

  // ── Kolejka ryzyk ─────────────────────────────────────────────────────────
  risk: {
    title:    "Operational risk queue",
    viewAll:  "View all",
    noRisks:  "No active operational risks",
    loading:  "Loading...",
  },

} as const;

export default enPmsManagerDashboard;
